export default __webpack_public_path__ + "static/media/dog-right.97f668e5.png";